import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';
import { AcademyDemoRequestService } from 'src/app/services/academy-demo-request.service';
import { saveAs } from 'file-saver/src/FileSaver';

@Component({
  selector: 'app-academy-demo-request',
  templateUrl: './academy-demo-request.component.html',
  styleUrls: ['./academy-demo-request.component.scss'],
  providers: [ConfirmationService, TitleCasePipe, MessageService]
})
export class AcademyDemoRequestComponent implements OnInit {
  searchBy: any[] = [];
  searchby: any;
  startDate: Date;
  endDate: Date;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  sponsorsData: any;
  academyDemoRequestData:any;
  totalAcademyDemoRequestDataCount: number = 0;
  paginationOption: any;
  calvalue: Date;
  ucalvalue: Date;
  statuses: any[];
  errorMessage: any;
  showThumbNailImage: boolean = false;
  loading: boolean;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  thumbnailImageArray: any[] = [];
  downloadFlg: boolean;
  downloadacademydemoList: any;

  constructor(private router: Router, private academydemoRequestService: AcademyDemoRequestService, private messageService: MessageService, private confirmationService: ConfirmationService,
    private titlecasePipe: TitleCasePipe) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.loadAcademyDemoRequestList({});
  }



  loadAcademyDemoRequestList(event: LazyLoadEvent) {
    
    this.lastTableLazyLoadEvent = event;
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (event.filters != undefined && event.filters["player"] != undefined) {
      params += "&filterByPlayer=" + event.filters["player"].value;
    }
    if (event.filters != undefined && event.filters["comment"] != undefined) {
      params += "&filterByComment=" + event.filters["comment"].value;
    }
    // if (event.filters != undefined && event.filters["brandName"] != undefined) {
    //   params += "&filterByBrandName=" + event.filters["brandName"].value;
    // }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["createdBy"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdBy"].value;
    }
    if (event.filters != undefined && event.filters["updatedBy"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedBy"].value;
    }

    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    

      if (event.sortField != undefined && event.sortOrder != undefined) {
        let orderBy = "";
        if (event.sortOrder == 1) {
          orderBy = "DESC";
        } else {
          orderBy = "ASC";
        }
        query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
      }
      
      this.academydemoRequestService.getAcademyDemoRequest(query).subscribe((data: any) => {    
        console.log("data",data);    
      if (this.downloadFlg === true) {
        this.exportExcelSheet(data.items);
      } else {       
        this.academyDemoRequestData = data.items;
        
        this.totalAcademyDemoRequestDataCount = data.items.totalCount;
      }
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }



  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'player', 'contains');
    this.dt.filter('', 'comment', 'contains');    
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'createdBy', 'contains');
    this.dt.filter('', 'updatedBy', 'contains');
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadAcademyDemoRequestList(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(academydemoList) {
      var propertiesRemove = ['_id','disable','created_by','updated_by'];
      this.downloadacademydemoList = academydemoList;
      this.downloadacademydemoList.forEach(function (item) {
          if (item.status) {
              item['status'] = 'Active';
          } else {
              item['status'] = 'In-Active';
          }
          propertiesRemove.forEach(function (prop) {
              delete item[prop];
          });
      });
      this.downloadacademydemoList.forEach(function (item) {
          propertiesRemove.forEach(function (prop) {
              delete item[prop];
          });
      });

      import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.downloadacademydemoList);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "academydemoList");
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
          });
          let filename;
          filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
           saveAs(data, filename);
      });
    }

  changeStatus(academyDemoRequestData) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(academyDemoRequestData.title)) + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var updatedata = {};
        updatedata['status'] = academyDemoRequestData.status;
        this.academydemoRequestService.updateAcademyDemoRequest(academyDemoRequestData._id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Article Status Updated', life: 3000 });
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        academyDemoRequestData.status = !academyDemoRequestData.status;
        this.loadAcademyDemoRequestList(this.lastTableLazyLoadEvent);
      }
    });
  }
  onDelete(academyDemoRequestData) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' +(this.titlecasePipe.transform(academyDemoRequestData.title))+ '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var updatedata = '{"disable":true}';        
        this.academydemoRequestService.updateAcademyDemoRequest(academyDemoRequestData._id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Article Deleted', life: 3000 });
            this.loadAcademyDemoRequestList(this.lastTableLazyLoadEvent);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadAcademyDemoRequestList(this.lastTableLazyLoadEvent);
      }
    });
  }
 
}
